"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("fake-number-input");
var FakeNumberInput = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var children = _a.children, _c = _a.editable, editable = _c === void 0 ? false : _c;
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("value"), (_b = {}, _b[c("value", "editable")] = editable, _b)) }, children),
        editable && (react_1.default.createElement("div", { className: c("spinner") },
            react_1.default.createElement(icons_1.ChevronUp, null),
            react_1.default.createElement(icons_1.ChevronDown, null)))));
});
exports.default = FakeNumberInput;
